import React from 'react';
import { Shield, Link2, Unlink } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const SecurityTab = ({
  passwordForm, setPasswordForm, saving, handleChangePassword,
  socialProviders, connectedAccounts, handleConnectAccount, inputClass
}) => (
  <div className="space-y-6">
    <Card className="bg-card border-border">
      <CardHeader>
        <CardTitle className="text-foreground">Change Password</CardTitle>
        <CardDescription className="text-muted-foreground">Update your account password</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="current-password" className="text-foreground/80">Current Password</Label>
          <Input id="current-password" data-testid="current-password-input" type="password" value={passwordForm.current} onChange={(e) => setPasswordForm({ ...passwordForm, current: e.target.value })} className={`mt-1 ${inputClass}`} />
        </div>
        <div>
          <Label htmlFor="new-password" className="text-foreground/80">New Password</Label>
          <Input id="new-password" data-testid="new-password-input" type="password" value={passwordForm.newPass} onChange={(e) => setPasswordForm({ ...passwordForm, newPass: e.target.value })} className={`mt-1 ${inputClass}`} />
        </div>
        <div>
          <Label htmlFor="confirm-password" className="text-foreground/80">Confirm New Password</Label>
          <Input id="confirm-password" data-testid="confirm-password-input" type="password" value={passwordForm.confirm} onChange={(e) => setPasswordForm({ ...passwordForm, confirm: e.target.value })} className={`mt-1 ${inputClass}`} />
        </div>
        <Button data-testid="update-password-btn" onClick={handleChangePassword} disabled={saving || !passwordForm.current || !passwordForm.newPass} className="bg-blue-600 hover:bg-blue-500">{saving ? 'Updating...' : 'Update Password'}</Button>
      </CardContent>
    </Card>

    <Card className="bg-card border-border">
      <CardHeader>
        <CardTitle className="text-foreground">Connected Accounts</CardTitle>
        <CardDescription className="text-muted-foreground">Manage your linked social login providers</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {socialProviders.map((account) => (
          <div key={account.key} className="flex items-center justify-between p-4 bg-muted rounded-lg border border-border" data-testid={`connected-${account.key}`}>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-accent rounded-lg flex items-center justify-center">
                <account.icon className={`w-5 h-5 ${account.color}`} />
              </div>
              <div>
                <span className="text-foreground font-medium text-sm">{account.name}</span>
                {connectedAccounts[account.key] && <p className="text-xs text-emerald-400">Linked to your account</p>}
              </div>
            </div>
            {connectedAccounts[account.key] ? (
              <span className="flex items-center gap-1.5 text-xs text-emerald-400 font-medium px-3 py-1.5 bg-emerald-500/10 rounded-lg border border-emerald-500/20" data-testid={`connected-status-${account.key}`}>
                <Link2 className="w-3.5 h-3.5" /> Connected
              </span>
            ) : (
              <Button size="sm" variant="outline" onClick={() => handleConnectAccount(account.key)} className="border-input text-muted-foreground hover:bg-accent text-xs gap-1.5" data-testid={`connect-btn-${account.key}`}>
                <Unlink className="w-3.5 h-3.5" /> Connect
              </Button>
            )}
          </div>
        ))}
      </CardContent>
    </Card>

    <Card className="bg-card border-red-500/30">
      <CardHeader>
        <CardTitle className="text-red-400">Danger Zone</CardTitle>
        <CardDescription className="text-muted-foreground">Irreversible actions</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-foreground font-medium text-sm">Delete Account</p>
            <p className="text-xs text-muted-foreground">Permanently delete your account and all data</p>
          </div>
          <Button variant="outline" className="border-red-500/40 text-red-400 hover:bg-red-500/10" data-testid="delete-account-btn">Delete Account</Button>
        </div>
      </CardContent>
    </Card>
  </div>
);

export default SecurityTab;
